import { Button } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';
import { useTranslation } from 'react-i18next';
import { LuTrash2 } from 'react-icons/lu';

type Props = {
    iconOnly?: boolean;
    onClick: () => void;
    translationPath?: string;
    testId?: string;
    disabled?: boolean;
};

const ItemDeleteButton: React.FC<Props> = ({ disabled, iconOnly = false, onClick, testId, translationPath }) => {
    const { t } = useTranslation();
    const label = t((translationPath || 'GENERAL_ITEM_DELETE_BUTTON') as never);

    return (
        <Button
            ariaLabel={iconOnly ? label : undefined}
            type="button"
            variant={ButtonVariant.SECONDARY}
            onClick={onClick}
            data-testid={testId}
            disabled={disabled}
            className={iconOnly ? 'h-8 w-8 shrink-0' : undefined}
            iconLeft={<LuTrash2 size={14} />}
        >
            {!iconOnly && <span>{label}</span>}
        </Button>
    );
};

export default ItemDeleteButton;
